(function () {
  'use strict';

  function focusOn() {
    return function (scope, elem, attr) {
      scope.$on('focusOn', function (e, name) {
        if (name === attr.hqToolsLightingFocusOn) {
          elem[0].focus();
        }
      });
    };
  }

  angular
    .module('hq.tools.lighting')
    .directive('hqToolsLightingFocusOn', focusOn);
}());
